<template>
  <div>
    <button v-if="shouldRender" class="open-btn" @click="toggleModal">
      <DotsMenu />
    </button>

    <Portal :to="PORTAL_NAMES.MODAL_DEFAULT" v-if="open">
      <OptionsModal
        :close="toggleModal"
        :updateAlternative="partialOptions => updateOption(partialOptions)"
        :alternative="alternative"
        :questions_groups_index="questions_groups_index"
        :question_index="question_index"
        :property="property"
      />
    </Portal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import DotsMenu from '@/components/imgs/DotsMenu'

import OptionsModal from './Modal.vue'

import { PORTAL_NAMES, ANSWER_TYPES } from '@/utils/constants'
import { questionsConfig } from '@/utils/questions'
import { alternativesRenderConfig } from '@/utils/alternativeOptions'

import * as translationIndex from './index.translations'

const { default: translations, ...translationKeys } = translationIndex

export default {
  name: 'AlternativesAdvancedOptions',

  components: {
    DotsMenu,
    OptionsModal,
  },

  data() {
    return {
      translations,
      PORTAL_NAMES,
      ...translationKeys,
      collapsePanel: false,
      open: false,
    }
  },

  props: {
    updateAlternative: {
      required: true,
      type: Function,
    },
    questions_groups_index: {
      required: true,
      type: Number,
    },
    question_index: {
      required: true,
      type: Number,
    },
    id: {
      required: true,
      type: String,
    },
    property: {
      required: true,
      type: String,
    },
    alternative: {
      required: true,
      type: Object,
    },
  },

  computed: {
    ...mapState(['questionGroups']),

    question() {
      return this.questionGroups[this.questions_groups_index].questions[
        this.question_index
      ]
    },

    type() {
      return this.question.type
    },

    typeConfig() {
      return questionsConfig[this.type]
    },

    alternativesConfig() {
      const alternativeProp =
        this.property === ANSWER_TYPES.answers ? 'answerConfig' : 'subQuestionConfig'

      return this.typeConfig[alternativeProp]
    },

    shouldRender() {
      return Object.values(alternativesRenderConfig).some(({ renderChecker }) =>
        renderChecker(this.question, this.property, this.questionGroups),
      )
    },
  },

  watch: {},

  methods: {
    ...mapActions(['sendMessage']),

    toggleModal() {
      this.open = !this.open
    },

    updateOption(partialOptions) {
      this.updateAlternative({
        ...this.alternative,
        ...partialOptions,
      })
    },
  },
}
</script>

<style scoped lang="scss">
.open-btn {
  @include transparentButton;
}
</style>
